import { CustomEventNames, EventTypes, logEvent } from 'state/amplitude';

import { TLogSupportFormSubmission } from '../types';

export const useKnowledgeForceCaseCreationLogging = () => {
  const logSupportFormSubmission: TLogSupportFormSubmission = ({
    userIssue,
    formData,
    caseRefNumber,
  }) => {
    const logEventProps = {
      'Issue ID': userIssue ? userIssue.knowledgeForceIssueId : 'No Issue Id',
      'Issue Name': userIssue ? userIssue?.name?.locale : 'Untitled',
      'Issue Description': formData.comments,
      'Marketforce Reference': caseRefNumber,
    };

    logEvent(CustomEventNames.SUPPORT_FORM_SUBMIT, EventTypes.Other, logEventProps);
  };

  return { logSupportFormSubmission };
};
